module.exports = __webpack_public_path__ + "static/qustart-33e263c6ccb0215e91bca46e4b86e479.png";